import DocketwiseHome from '@/views/integrations/DocketwiseHome'

export const docketwiseRoutes = {
  path: '/integrations/docketwise',
  name: 'integrationDocketwise',
  meta: { requiresAuth: true, title: 'Docketwise Integration - Innovation Law Lab Platform' },
  component: DocketwiseHome,
  props: true,
  redirect: { name: 'user-account-integration-settings' },
  children: [
    {
      path: 'callback',
      name: 'int-docketwise-callback',
      meta: { requiresAuth: true, callback: true, title: 'Docketwise Integration - Innovation Law Lab Platform' },
      props: true,
      component: _ => import('@/components/Integrations/Docketwise/DocketwiseCallback'),
    },
  ],
}
